export default class socialSharer {

  constructor() {
    this.facebook = "https://www.facebook.com/sharer/sharer.php?";
    this.twitter = "https://twitter.com/home?";
    this.shareButtons = document.querySelectorAll('.share-box__list .item a');
    Array.from(this.shareButtons).forEach(button => {
      button.addEventListener('click', (e) => this.shareInfo(e));
    });
  }

  renderShareWindow(url, title) {
    const width = 575;
    const height = 400;
    const left = ($(window).width() - width) / 2;
    const top = ($(window).height() - height) / 2;
    const opts = 'status=1' +
      ',width=' + width +
      ',height=' + height +
      ',top=' + top +
      ',left=' + left;
    window.open(url, title, opts);
    return false;
  }

  shareInfo(e) {
    e.preventDefault();

    const shareButton = e.target.closest('a');
    const url = shareButton.getAttribute('href');

    if (shareButton.classList.contains('facebook') && this.facebook) {
      const socialUrl = this.facebook + "u=" + url;
      this.renderShareWindow(encodeURI(socialUrl));
    }

    if (shareButton.classList.contains('twitter') && this.twitter) {
      const socialUrl = this.twitter + "status=" + url;
      this.renderShareWindow(encodeURI(socialUrl));
    }
  }
}



// WEBPACK FOOTER //
// ./scripts/socialSharer.js